import React from 'react'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Select from 'react-select';

import {cadastrarCupom, alterarCupom} from '../../actions/cupom/cuponsActions'
import {
    renderFieldEmail,
    renderField,
    renderFieldHora,
    required,    
    requiredSelect,
    renderFieldNumerosPorcentagem2,
    requiredNumeric
} from '../../util/inputs';

import {showErrorMsg, showSuccessMsg, showAlertMsg} from '../../util/messagesUtil';
import DatePicker from 'react-datepicker';
import moment from 'moment';

export class ModalCadastrarCupom extends React.Component {
    constructor(props) {
        super(props);
        this.limparCampos = this.limparCampos.bind(this);
        this.submit = this.submit.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);

    }

    componentDidMount() {


    }

    componentDidUpdate(prevProps) {
        if (!prevProps.identificacao && !this.props.cupom) {
            this.gerarIdentificador()
        }
        if (!prevProps.horaFim) {
            this.props.changeFieldValue('formularioCadastroCupom', 'horaFim', '23:00')
        }
        if (!prevProps.horaInicio) {
            this.props.changeFieldValue('formularioCadastroCupom', 'horaInicio', '01:00')
        }
    }

    gerarIdentificador() {
        const identificador = Date.now() + Math.random().toString()
        this.props.changeFieldValue('formularioCadastroCupom', 'identificacao',
            identificador.split('.')[1])

    }

    exibirComboTipo(event) {
        const {tipos} = this.props;
        if (tipos) {
            return (
                <div>
                    <Select
                        {...event.input}
                        noOptionsMessage={() => ('Nenhuma opção encontrada')}
                        placeholder='Selecione um tipo...'
                        options={tipos.map(elemento => ({
                            label: elemento.descricao,
                            value: elemento.name
                        }))}
                        onChange={value => event.input.onChange(value)}
                        onBlur={() => event.input.onBlur()}
                    />
                    {event.meta.touched
                    && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
                </div>
            )
        }

    }

    exibirComboPlataforma(event) {
        const {plataformas} = this.props;
        return (
            <div>
                <Select
                    {...event.input}
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    placeholder='Selecione um tipo...'
                    options={plataformas.map(elemento => ({
                        label: elemento,
                        value: elemento
                    }))}
                    onChange={value => event.input.onChange(value)}
                    onBlur={() => event.input.onBlur()}
                />
                {event.meta.touched
                && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
            </div>
        )
    }

    exibirComboOrigemRequisicaoCupom(event) {
        const {origensRequisicaoCupom} = this.props;
        if (origensRequisicaoCupom) {
            return (
                <div>
                    <Select
                        {...event.input}
                        noOptionsMessage={() => ('Nenhuma opção encontrada')}
                        options={origensRequisicaoCupom.map(elemento => ({
                            label: elemento.valor,
                            value: elemento.chave
                        }))}
                        onChange={value => event.input.onChange(value)}
                        onBlur={() => event.input.onBlur()}
                    />
                    {event.meta.touched
                        && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
                </div>
            )
        }
    }

    // eslint-disable-next-line class-methods-use-this
    montarParametroCupom(values) {
        return {
            id: values.id,
            dataInicio: values.dataInicio,
            dataFim: values.dataFim,
            identificacao: values.identificacao,
            email: values.email,
            tipo: values.tipo.value,
            plataforma: values.plataforma.value,
            quantidade: values.quantidade,
            horaInicio: values.horaInicio,
            horaFim: values.horaFim,
            porcentagem: this.ehCortesia() ? '100' : values.porcentagem,
            origemRequisicao: values.origemRequisicao.value
        };
    }

    submit(values) {
        if (values.id) {
            this.props.alterarCupom(this.montarParametroCupom(values)).then(() => {                
                showSuccessMsg('Cupom atualizado com sucesso');
                this.props.buscarCupons()
            });
        } else {
            this.props.cadastrarCupom(this.montarParametroCupom(values)).then((data) => {
                const cupom = data.payload;
                if(cupom){
                    if (cupom.ativo) {
                        showSuccessMsg('Cupom cadastrada com sucesso');
                    } else {
                        showAlertMsg('Já existe um cupom ativo com a mesma identificacao nesta plataforma, criaremos ele inativo, caso queira editar.');
                    }
                }
                
                this.limparCampos();
                this.props.buscarCupons()
            })
        }
    }

    limparFormulario() {
        this.props.reset('formularioCadastroCupom');
        this.props.selecionarCupom(null);
    }

    limparCampos() {
        this.props.changeFieldValue('formularioCadastroCupom',
            'idPreco', '');
        this.props.changeFieldValue('formularioCadastroCupom',
            'dataInicio', '');
        this.props.changeFieldValue('formularioCadastroCupom',
            'dataFim', '');
        this.props.changeFieldValue('formularioCadastroCupom',
            'identificacao', '');
        this.props.changeFieldValue('formularioCadastroCupom',
            'email', '');
        this.props.changeFieldValue('formularioCadastroCupom',
            'tipo', '');
        this.props.changeFieldValue('formularioCadastroCupom',
            'plataforma', '');
        this.props.changeFieldValue('formularioCadastroCupom',
            'quantidade', '');
    }

    onChangeDateInicio = (date) => {
        this.props.changeFieldValue('formularioCadastroCupom',
            'dataInicio', date);
    };

    onChangeDateFim = (date) => {
        if (moment(this.props.dataInicio, 'DD/MM/YYYY').isBefore(moment(date, 'DD/MM/YYYY')))
            this.props.changeFieldValue('formularioCadastroCupom', 'dataFim', date);
        else
            showErrorMsg('Data fim menor que data início.')
    };

    exibirCalendarioInicio(event) {
        return (
            <div>
                <div className="linha">
                    <DatePicker
                        className='form-control col-md-12'
                        selected={this.props.dataInicio}
                        locale="pt-BR"
                        onChange={date => this.onChangeDateInicio(date)}
                        placeholder={this.props.dataInicio}
                        dateFormat="dd/MM/yyyy"
                        withPortal
                    />
                </div>
                {event.meta.touched
                && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
            </div>
        )
    }

    exibirCalendarioFim(event) {
        return (
            <div>
                <div className="linha">
                    <DatePicker
                        className='form-control col-md-12'
                        selected={this.props.dataFim}
                        locale="pt-BR"
                        onChange={date => this.onChangeDateFim(date)}
                        placeholder={this.props.dataFim}
                        dateFormat="dd/MM/yyyy"
                        withPortal
                    />
                </div>
                {event.meta.touched
                && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
            </div>
        )
    }

    ehCortesia() {
        return this.props.tipo && this.props.tipo.value === 'CORTESIA'
    }

    render() {
        const {handleSubmit} = this.props;
        return (
            <div className="modal fade show" id='modalCadastrarCupom' role='dialog'
                 aria-labelledby='modalCadastrarCupom' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-lg'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>{this.props.cupom ? 'Editar Cupom' : 'Novo Cupom'}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                    onClick={this.limparFormulario}>
                                <i className="material-icons">
                                    close
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit(this.submit)}>
                                <div className="form-row">
                                    <div className="col-12">
                                        <div className="form-row mt-2">
                                            <div className="col-12 col-sm-4 col-md-4 mt-2">
                                                <label>Data início</label>
                                                <Field name="dataInicio" type="texto"
                                                       component={this.exibirCalendarioInicio.bind(this)}
                                                       css="form-control col-md-12" readOnly={false}/>
                                            </div>
                                            <div className="col-12 col-sm-2 col-md-2">
                                                <Field name="horaInicio"
                                                       css='form-control'
                                                       component={renderFieldHora}
                                                       label="Hora"/>
                                            </div>
                                            <div className="col-12 col-sm-4 col-md-4 mt-2">
                                                <label>Data fim</label>
                                                <Field name="dataFim" type="texto"
                                                       component={this.exibirCalendarioFim.bind(this)}
                                                       css="form-control col-md-12" readOnly={false}/>

                                            </div>
                                            <div className="col-12 col-sm-2 col-md-2">
                                                <Field name="horaFim"
                                                       css='form-control'
                                                       component={renderFieldHora}
                                                       label="Hora"/>
                                            </div>

                                        </div>
                                        <div className="form-row mt-2">
                                            <div className="col-12 col-sm-6 col-md-6">
                                                <label>Origem</label>
                                                <Field name='origemRequisicao'
                                                       component={this.exibirComboOrigemRequisicaoCupom.bind(this)}/>
                                            </div>
                                        </div>
                                        <div className="form-row mt-2">
                                            <div className="col-12 col-sm-6 col-md-6">
                                                <label>Plataforma</label>
                                                <Field name='plataforma'
                                                       validate={[requiredSelect]}
                                                       component={this.exibirComboPlataforma.bind(this)}/>
                                            </div>
                                            <div className="col-12 col-sm-6 col-md-6">
                                                <label>Tipo cupom</label>
                                                <Field name='tipo'
                                                       validate={[requiredSelect]}
                                                       component={this.exibirComboTipo.bind(this)}/>
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="col-12 col-sm-3 col-md-3">
                                                <Field name="quantidade"
                                                       css='form-control'
                                                       validate={[required]}
                                                       component={renderField}
                                                       label="Quantidade"/>
                                            </div>
                                            {this.ehCortesia() ?
                                                <div className="col-12 col-sm-9 col-md-9">
                                                    <Field name="email"
                                                           css='form-control'
                                                           component={renderFieldEmail}
                                                           label="email"/>
                                                </div> : ''
                                            }
                                        </div>
                                        <div className="form-row">
                                            <div className="col-12 col-sm-6 col-md-6">
                                                <Field name="identificacao" type="texto"
                                                       component={renderField}
                                                       validate={[required]}
                                                       label='Identificação'
                                                       css="form-control" readOnly={false}/>
                                            </div>
                                            <div className="col-12 col-sm-4 col-md-4">
                                                {!this.ehCortesia() ?
                                                    <Field name='porcentagem' validate={[requiredNumeric]}
                                                           component={renderFieldNumerosPorcentagem2}
                                                           css="form-control" label="Porcentagem(%):"/>
                                                    : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group area-codigo">
                                    <Field name="idCupom" type="hidden" component={renderField}
                                           css="form-control col-md-12"/>
                                </div>
                                <div className="modal-footer">
                                    <button type="submit"
                                            className="btn btn-laranja">Salvar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        initialValues: {
            origemRequisicao: {value: null, label: 'Todos'}
        },
        idCupom: formValueSelector('formularioCadastroCupom')(state, 'idCupom'),
        tipo: formValueSelector('formularioCadastroCupom')(state, 'tipo'),
        dataInicio: formValueSelector('formularioCadastroCupom')(state, 'dataInicio'),
        dataFim: formValueSelector('formularioCadastroCupom')(state, 'dataFim'),
        horaInicio: formValueSelector('formularioCadastroCupom')(state, 'horaInicio'),
        horaFim: formValueSelector('formularioCadastroCupom')(state, 'horaFim'),
        identificacao: formValueSelector('formularioCadastroCupom')(state, 'identificacao'),
        quantidade: formValueSelector('formularioCadastroCupom')(state, 'quantidade'),
        origemRequisicao: formValueSelector('formularioCadastroCupom')(state, 'origemRequisicao'),
        paginaAtual: state.cupom.paginaAtualCupons,
        registrosPorPagina: state.cupom.registrosPorPaginaCupons,
        tipos: state.cupom.tipos,
        plataformas: state.plataformas,
        origensRequisicaoCupom: state.cupom.origensRequisicaoCupom
    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarCupom,
        alterarCupom
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioCadastroCupom'
})(ModalCadastrarCupom));
